// List proveedores
export const LIST_PROVEEDORES_REQUEST = 'LIST_PROVEEDORES_REQUEST';
export const LIST_PROVEEDORES_REQUEST_SUCCESS = 'LIST_PROVEEDORES_REQUEST_SUCCESS';
export const LIST_PROVEEDORES_REQUEST_FAILURE = 'LIST_PROVEEDORES_REQUEST_FAILURE';
